module.exports = __webpack_public_path__ + "static/img/quality02.7dc402d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quality02.jpg
// module id = o4DN
// module chunks = 1